import { render, staticRenderFns } from "./SantralList.vue?vue&type=template&id=404c19fc&"
import script from "./SantralList.vue?vue&type=script&lang=js&"
export * from "./SantralList.vue?vue&type=script&lang=js&"
import style0 from "./SantralList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VCard,VCol,VDataTable})
